import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-info-orange',
  templateUrl: './icon-info-orange.component.html',
  styles: []
})
export class IconInfoOrangeComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
